<template>
  <b-card>
    <div class="d-flex mb-2">
      <div class="mr-auto"></div>
      <div>
        <b-button
          size="sm"
          variant="outline-danger"
          v-if="local_value.id"
          @click="removeFile"
        >
          <font-awesome-icon icon="plus" />
          Remover
        </b-button>

        <b-button size="sm" variant="bagsis" @click="selectFiles()">
          <font-awesome-icon icon="plus" />
          {{ local_value.id ? "Alterar Arquivo" : "Adicionar Arquivo" }}
        </b-button>
      </div>
    </div>

    <CardFile :file="local_value" v-if="has_file" />

    <b-modal
      title="Adicionar Arquivo"
      :id="componentId"
      :ref="componentId"
      size="xl"
      ok-variant="bagsis"
      @ok="addFile"
      :footer-class="footer_class"
      @hide="hideModal"
    >
      <b-tabs v-model="tabIndex" content-class="mt-3">
        <b-tab title="Adicionar Arquivo" active>
          <TableList
            :show_actions="false"
            :show_select="true"
            :show_btn_novo="false"
            :max_select="1"
            :type="type"
            ref="files_selected"
          />
        </b-tab>
        <b-tab title="Criar Arquivo">
          <b-card>
            <Form
              @saved="arquivoCriado"
              :selectFile="true"
              :cancel_link="''"
              @cancel="voltar"
              :type="type"
            />
          </b-card>
        </b-tab>
      </b-tabs>
    </b-modal>
  </b-card>
</template>

<script>
import TableList from "@/modules/files/Components/TableList.vue";
import Form from "@/modules/files/Components/Form.vue";
import CardFile from "./CardFile.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";
import { generateId } from "@/helpers/functions/generateId";

export default {
  components: {
    TableList,
    Form,
    CardFile,
  },
  data: () => ({
    tabIndex: 0,
    componentId: null,
  }),
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState("files", ["file"]),
    ...mapGetters("files", ["file_empty"]),
    local_value: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.value ? this.value : this.file_empty;
      },
    },
    has_file() {
      return this.value && this.value.id;
    },
    footer_class() {
      if (this.tabIndex == 1) {
        return "d-none";
      }
      return "";
    },
  },
  methods: {
    ...mapActions("files", ["ActionNewFile"]),
    addFile(evt) {
      evt.preventDefault();
      let files = this.$refs.files_selected.getSelected();
      this.local_value = files[0];

      this.$nextTick(() => {
        this.$bvModal.hide(this.componentId);
      });
    },
    selectFiles() {
      this.$bvModal.show(this.componentId);
    },
    arquivoCriado(files) {
      this.local_value = files[0];
      this.$nextTick(() => {
        this.ActionNewFile();
        this.$bvModal.hide(this.componentId);
      });
    },
    voltar() {
      this.tabIndex = 0; // 2
    },
    hideModal() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      delete query.page;
      this.$router.push({ query: query }).catch((err) => {});
    },
    removeFile() {
      this.local_value = null;
    },
  },
  async created() {
    this.ActionNewFile();
    this.componentId = "modal-arquivo-" + generateId();
  },
};
</script>

<style></style>
